import { Button, Col, Form, InputNumber, Row, Select, Space, Table, Tooltip } from 'antd';
import React, { ReactElement, useEffect, useState } from 'react';
import Panel from '../../../../shared/components/card/Panel';
import { APPLICATION_ID, FETCH_PACKAGE, GUTTOR_SPACE, PACKAGE_TYPE, StatusFilterType, TOOLTIP_TEXT } from '../../../../shared/constants/commonConstants';
import { DEPARTMENT_HC, FETCH_INVESTIGATIONS, INVENTORY_SAVE_LABTEST } from '../../../../shared/constants/urlEndPoints';
import { FetchInvestigationRequest, FetchInvestigationResponse } from '../../../../shared/models/investigation.model';
import { LabTestPackage, SavelabTestPackage } from '../../../../shared/models/labtest.model';
import { FetchPackageRequest, FetchPackageResponse } from '../../../../shared/models/packageDetail.model';
import SendRequest from '../../../../shared/services/sendRequest.service';
import { base64UrlDecode, error, success } from '../../../../utils/utility';
import { Test } from '../../../../shared/models/healthcheck.model';
import ApplicationDetail from '../../../../shared/services/applicationDetail.service';
import _ from 'lodash';
import { ReactComponent as CloseIcon } from '../../../../assets/images/svg/i_close.svg';
import CustomInputNumber from '../../shared/CustomInputNumber';

const LabTestForm = ({ groupId: grupId, packageId: pId }: any): ReactElement => {

  const [labTestDepartments, setlabTestDepartmentsHandler] = useState(null as any);
  const [investigations, setInvestigationsHandler] = useState(null as any);
  const [groupName, setgroupNameHandler] = useState(null as any);
  const [existingPackages, setExistingPackages] = useState(null as any);
  const [tableData, settableDataHandler] = useState([] as any);
  const [labTestsInFilter, setlabTestsInFilterHandler] = useState([] as any);
  const [discountPercent, setDiscuntPercent] = useState(0);

  const profileId = [ApplicationDetail.instance.getProfileId()];
  const groupId = base64UrlDecode(grupId);
  const packageId = base64UrlDecode(pId);
  useEffect((): void => {
    fetchLabTestDepartments();
    if (+groupId) {
      filterLabTestPackages([+groupId], [packageId]);
      fetchTests(+groupId);
    }
  }, [groupId]);

  const fetchLabTestDepartments = async (): Promise<void> => {
    const departmentResponse = await SendRequest.instance.get(process.env.REACT_APP_INVENTORY_API_BASE_URL + DEPARTMENT_HC);
    if (departmentResponse && departmentResponse.isSuccess && departmentResponse.lookUpData) {
      departmentResponse.lookUpData.forEach((x: any): void => x.key = x.id);
      setlabTestDepartmentsHandler(departmentResponse.lookUpData);
      if (groupId !== '0' && departmentResponse.lookUpData?.filter((x: any): any => x.id === parseInt(groupId, 10)).length > 0) {
        setgroupNameHandler(departmentResponse.lookUpData?.filter((x: any): any => x.id === parseInt(groupId, 10))[0].value);
      }
    } else if (departmentResponse && departmentResponse.errorMessage) {
      Error(departmentResponse.errorMessage);
      setInvestigationsHandler(null);
    } else {
      Error('Unable to fetch departments. Please try after some time.');
      setInvestigationsHandler(null);
    }
  };

  const fetchTests = async (
    gpId: number,
  ): Promise<any> => {
    const url = process.env.REACT_APP_INVENTORY_API_BASE_URL + FETCH_INVESTIGATIONS;
    const reqpayload: FetchInvestigationRequest = {
      groupIds: [gpId],
      pageNumber: 1,
      pageSize: 5000,
    };
    const result: any = await SendRequest.instance.post<
      FetchInvestigationRequest,
      FetchInvestigationResponse
    >(url, reqpayload);
    if (result && result.isSuccess && result.packageDetails && result.packageDetails.length > 0) {
      const tData = [] as any;
      result.packageDetails.map((item: any): any => (
        tData.push({
          key: item.id,
          groupid: item.groupId,
          name: item.name,
          groupname: item.groupName,
          value: item.name,
          descp: item.description,
        })
      ));
      setInvestigationsHandler(tData);
    } else {
      error('Unable to fetch investigations. Please try after some time.');
      setInvestigationsHandler(null);
    }
  };
  const filterLabTestPackages = async (deptIds: number[], packageIds: any[]): Promise<any> => {
    const payload: FetchPackageRequest = {
      packageType: PACKAGE_TYPE.LABTEST,
      fetchInActiveRecord: true,
      pageNumber: 1,
      pageSize: 500,
      departmentIds: deptIds,
      packageByDepartmentId: deptIds !== null && deptIds.length > 0,
      packageByProfileId: true,
      profileIds: profileId,
    };
    const url = process.env.REACT_APP_INVENTORY_API_BASE_URL + FETCH_PACKAGE;
    const result: any = await SendRequest.instance.post<
      FetchPackageRequest,
      FetchPackageResponse
    >(url, payload);
    if (result && result.isSuccess) {
      const validPackages = result.packages?.filter((item: any): any => item?.investigations !== undefined) || [];
      if (packageIds !== null && packageIds.length > 0 && packageIds[0] !== '0' && packageIds[0] !== 0) {
        const selectedPackage = validPackages?.filter((x: any): any => x?.id === parseInt(packageId, 10)) || [];
        assignDataToTable(selectedPackage);
        const inv = [] as any;
        inv.push(selectedPackage[0]?.investigations[0]?.name);
        setlabTestsInFilterHandler(inv);
      } else {
        assignDataToTable(validPackages);
      }
      setExistingPackages(validPackages);
    } else {
      settableDataHandler(null);
    }
  };

  const onDepartmentSelection = async (item: any): Promise<any> => {
    setgroupNameHandler(item.value);
    fetchTests(item.id);
    setlabTestsInFilterHandler([]);
    filterLabTestPackages([item.id], [0]);
  };

  const array_move = (arr: any[], old_index: number, new_index: number): any => {
    if (new_index >= arr.length) {
      let k = new_index - arr.length + 1;
      while (k--) {
        arr.push(undefined);
      }
    }
    arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
    return arr;
  };

  const onLabTestClear = async (item: any): Promise<void> => {
    if (tableData?.length > 0) {
      tableData.splice(tableData.findIndex((x: any): any => x.Name.trim() === item.trim()), 1);
      settableDataHandler([...tableData]);
      if (labTestsInFilter) {
        labTestsInFilter.splice(labTestsInFilter.indexOf(item), 1);
        setlabTestsInFilterHandler([...labTestsInFilter]);
      }
    }
  };

  const onInvestigationSelection = async (items: any): Promise<any> => {
    const investigationNames = [] as any;
    if (labTestsInFilter) {
      labTestsInFilter.map((i: any): any => {
        investigationNames.push(i);
      });
    }
    const existigtData = tableData ? [...tableData] : [];
    items.map((item: any): void => {
      if (item && !_.isEmpty(item)) {
        if (!investigationNames.some((i: any): any => item.name.trim() === i.trim())) {
          investigationNames.push(item.name);
        }
        let found = false as boolean;
        existigtData.map((x: any, index: number): void => {
          if (x.InvestigationId === item.key) {
            x.isNewlyAdded = true;
            found = true;
            settableDataHandler(array_move(existigtData, index, 0));
            return;
          }
        });
        if (!found && existingPackages) {
          existingPackages.map((x: any): void => {
            if (x.investigations[0].id === item.key) {
              found = true;
              existigtData.push({
                Key: x.id,
                Active: x.isActive,
                Name: x.investigations[0].name,
                Description: x.investigations[0].description,
                MRP: x.price,
                DiscountPrice: x.discountedPrice,
                Status: x.isApproved,
                GroupName: x.investigations[0].groupName,
                GroupId: x.investigations[0].groupId,
                InvestigationId: x.investigations[0].id,
                Existing: true,
                isNewlyAdded: true,
              });
              settableDataHandler(array_move(existigtData, existigtData.length - 1, 0));
              return;
            }
          });
        }
        if (!found) {
          existigtData.push({
            Key: 0,
            Active: true,
            Name: item.name,
            Description: item.descp,
            MRP: 0,
            DiscountPrice: 0,
            Status: 'Submit',
            GroupName: item.groupname,
            GroupId: item.groupid,
            InvestigationId: item.key,
            Existing: false,
            isNewlyAdded: true,
          });
          settableDataHandler(array_move(existigtData, existigtData.length - 1, 0));
        }
      }
    });
    setlabTestsInFilterHandler(investigationNames);
  };

  const assignDataToTable = (data: any[]): void => {
    const packages = data === null || data.length === 0 ? existingPackages : data;
    if (packages) {
      const tblData = [] as any;
      packages.map((item: any): any => (
        tblData.push({
          Key: item.id,
          Active: item.isActive,
          Name: item.investigations[0].name,
          Description: item.investigations[0].description,
          MRP: item.price,
          DiscountPrice: item.discountedPrice < 1 ? item.price : item.discountedPrice,
          Status: item.isApproved,
          GroupName: item.investigations[0].groupName,
          GroupId: item.investigations[0].groupId,
          InvestigationId: item.investigations[0].id,
          Existing: true,
        })
      ));
      settableDataHandler(tblData);
    }
  };

  const onFocusOut = (value: string, record: any): void => {
    tableData.filter((x: any): void => {
      if (x.InvestigationId === record.InvestigationId) {
        x.IsChanged = x.MRP !== value;
        x.MRP = value;
        const discount = Math.round((discountPercent * x.MRP) / 100);
        x.DiscountPrice = x.MRP - discount;
      }
    });
    settableDataHandler([...tableData]);
  };

  const onFocusOutDisc = (value: string, record: any): void => {
    tableData.filter((x: any): void => {
      if (x.InvestigationId === record.InvestigationId) {
        x.IsChanged = x.MRP !== value;
        x.DiscountPrice = value;
      }
    });
    settableDataHandler([...tableData]);
  };

  const columns = [
    {
      title: 'Name',
      dataIndex: 'Name',
      key: 'name',
      width: '15%',
      render: (text: any, record: any): any => {
        return {
          props: {
            className: record.isNewlyAdded ? 'ant-typography-progress' : '',   // there it is!
          },
          children: text,
        };
      },
    },
    {
      title: 'Description',
      dataIndex: 'Description',
      key: 'description',
      width: '50%',
      render: (text: any, record: any): any => {
        return {
          props: {
            className: record.isNewlyAdded ? 'ant-typography-progress' : '',   // there it is!
          },
          children: text,
        };
      },
    },
    {
      title: 'MRP',
      dataIndex: 'MRP',
      key: 'mrp',
      width: '15%',
      render: (e: any, record: any): any => (
        <CustomInputNumber
          prefix="₹ "
          min={0}
          value={record.MRP}
          style={{ width: '120px', textAlign: 'center', borderColor: (!record.MRP || parseInt(record.MRP, 10) < 1 || (isNaN(+record.MRP))) ? 'red' : '' }}
          onChange={(event: any): any => { onFocusOut(event, record); }}
        />
      ),
    },
    {
      title: 'Disc. price',
      dataIndex: 'Disc. Price',
      key: 'discPrice',
      width: '15%',
      render: (e: any, record: any): any => (
        <CustomInputNumber
          prefix="₹ "
          min={0}
          value={record.DiscountPrice}
          style={{
            width: '120px', textAlign: 'center',
            borderColor: (!record.DiscountPrice || parseInt(record.DiscountPrice, 10) < 1 || (isNaN(+record.DiscountPrice))) ? 'red' : '',
          }}
          onChange={(event: any): any => { onFocusOutDisc(event, record); }}
        />
      ),
    },
    {
      title: '',
      dataIndex: '',
      key: 'action',
      render: (text: any, record: any): any => (
        <Space>
          <Tooltip title={TOOLTIP_TEXT.remove}>
            <CloseIcon className="fill-close"
              onClick={(): void => onRemoveTestHandler(record)}
            />
          </Tooltip>
        </Space>
      ),
    },
  ];

  const onRemoveTestHandler = (record: any): void => {
    if (record) {
      const existingData = [...tableData.filter((x: any): any => x.InvestigationId !== record.InvestigationId)];
      settableDataHandler(existingData);
      labTestsInFilter.splice(labTestsInFilter.indexOf(record.Name, 0), 1);
      setlabTestsInFilterHandler([...labTestsInFilter]);
    }
  };

  const saveLabTestPackages = async (): Promise<void> => {
    const packagesToSave: LabTestPackage[] = [];
    tableData.map((item: any): void => {
      const test: Test = {
        departmentId: item.GroupId,
        investigationId: item.InvestigationId,
        isActive: true,
      };
      const labTestpackage = new LabTestPackage();
      labTestpackage.id = item.Key;
      labTestpackage.profileId = profileId[0];
      labTestpackage.test = test;
      labTestpackage.price = item.MRP;
      labTestpackage.discountedPrice = item.DiscountPrice;
      labTestpackage.packageName = item.Name;
      labTestpackage.statusName = StatusFilterType.isSubmit;
      labTestpackage.isActive = true;
      packagesToSave.push(labTestpackage);
    });

    const payload: SavelabTestPackage = {
      applicationId: APPLICATION_ID,
      labTests: packagesToSave,
    };
    const url = process.env.REACT_APP_INVENTORY_API_BASE_URL + INVENTORY_SAVE_LABTEST;
    const response: any = await SendRequest.instance.post(url, payload);
    if (response && response.isSuccess) {

      success('Tests successfully configured.');
    } else if (response && response.errorMessage) {
      error(response.errorMessage);
    } else {
      error('Unable to configure tests. Please try after some time.');
    }
    return;
  };

  useEffect((): any => {
    const existingDatainTable: any[] = [...(tableData || [])];
      existingDatainTable.map((x: any): any => {
        const discount = Math.round((discountPercent * x.MRP) / 100);
        x.DiscountPrice = x.MRP - discount;
      });
      settableDataHandler([...existingDatainTable]);
  }, [discountPercent]);

  return (<div>
    <Form >
      <Panel title={'Test details'}>
        <Row gutter={GUTTOR_SPACE} className="mb-lg">
          <Col md={6}>
            <p className="label-title">Department</p>
            <Select
              className="w-100"
              placeholder="Department"
              optionLabelProp="label"
              onChange={(val: any, option: any): any => onDepartmentSelection(option)}
              options={labTestDepartments}
              value={groupName}
            />
          </Col>
          <Col md={4}>
            <p className="label-title">Discount %</p>
            <InputNumber className="w-100"
              placeholder={'Discount'}
              min={1}
              max={100}
              onChange={(event: any): any => setDiscuntPercent(event || 0)} />
          </Col>
          <Col md={14}>
            <p className="label-title">Tests</p>
            <Select
              className="w-100"
              mode={'multiple'}
              placeholder="Search"
              optionLabelProp="label"
              onChange={(val: any, option: any): any => onInvestigationSelection(option)}
              options={investigations}
              value={labTestsInFilter}
              onDeselect={onLabTestClear}
            />
          </Col>
        </Row>
        <Table
          columns={columns}
          dataSource={tableData}
          pagination={false}
          scroll={{ y: 300 }}
          className="panel-table panel-table-border"
          bordered={false}
          size="small"
        />
        <div className="text-right mt-md">
          <Button type={'primary'} htmlType={'submit'} onClick={(): any => saveLabTestPackages()}>Save</Button>
        </div>
      </Panel>
    </Form>
  </div >);
};

export default LabTestForm;
